import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import './ArticleHeroB.scss';
import SocialShare from '../ArticleSocialShare/ArticleSocialShare';
import HeroNmpVideo, {
  heroNmpAutoplayOn,
  heroUsesNmpVideo,
} from '../HeroNmpVideo/HeroNmpVideo';

export default class ArticleHeroB extends Component {
  constructor(props) {
    super(props);
    const nmpAutoplay =
      heroUsesNmpVideo(props.heroVideoSource, props.nmpAssetId) &&
      heroNmpAutoplayOn(props.nmpAutoplay);
    this.state = { playing: nmpAutoplay };
  }

  render() {
    let {
      title,
      heroImage,
      highlightColor,
      textColor,
      postDate,
      youtubeId,
      heroImageWidth,
      heroVideoSource,
      nmpAssetId,
      nmpAutoplay,
      nmpHideControls,
      nmpMuted,
      nmpLoop,
      nmpTheme,
    } = this.props;

    const useNmp = heroUsesNmpVideo(heroVideoSource, nmpAssetId);
    const nmpAutoplayOn = useNmp && heroNmpAutoplayOn(nmpAutoplay);
    const hasYoutube = !useNmp && youtubeId;
    const hasVideo = useNmp || hasYoutube;
    const isVideoWidth = heroImageWidth === 'video';
    const nmpFit = 'contain';
    const isPlaying =
      nmpAutoplayOn || (this.state.playing && hasYoutube);

    const headlineStyle = {};
    if (textColor && textColor.startsWith('#')) {
      headlineStyle.color = textColor;
    }
    if (highlightColor && highlightColor.startsWith('#')) {
      headlineStyle.backgroundImage = `linear-gradient(90deg, ${highlightColor} 0, ${highlightColor} 0)`;
    }

    return (
      <div
        className={`article-hero-B ${hasVideo ? 'has-video' : ''} ${
          isVideoWidth ? 'article-hero-B--width-video' : ''
        } ${useNmp ? 'article-hero-B--has-nmp' : ''}`}
      >
        <div
          className={`article-hero-B__img-ctnr ${
            isPlaying && hasVideo ? 'playing' : ''
          }`}
          onClick={() => {
            if (hasYoutube && !nmpAutoplayOn) {
              this.setState({ playing: true });
            }
          }}
        >
          {heroImage && heroImage.background && (
            <div
              className={`article-hero-B__img ${hasVideo ? 'has-video' : ''}`}
              style={{
                backgroundImage: `url(${heroImage.background.dataOriginal})`,
                backgroundPosition: `${heroImage.focus.x * 100}% ${heroImage.focus.y * 100}%`,
              }}
              alt=""
            />
          )}
          {useNmp && (
            <HeroNmpVideo
              className="article-hero-B__nmp-video"
              fit={nmpFit}
              nmpAssetId={nmpAssetId}
              nmpAutoplay={nmpAutoplay}
              nmpHideControls={nmpHideControls}
              nmpMuted={nmpMuted}
              nmpLoop={nmpLoop}
              nmpTheme={nmpTheme}
            />
          )}
          {hasYoutube && (
            <React.Fragment>
              <ReactPlayer
                width={'100%'}
                height={'100%'}
                url={`${youtubeId}`}
                playing={this.state.playing}
                playsinline={false}
                className={'article-hero-B__video react-player'}
                config={{
                  youtube: {
                    playerVars: { rel: 0, controls: 1, playsinline: 0 },
                    embedOptions: {
                      host: 'https://www.youtube-nocookie.com',
                    },
                  },
                }}
              />
              {!nmpAutoplayOn && (
                <img
                  src="/icons/misc/VideoPlay.svg"
                  className="article-hero-B__play-btn play-btn"
                  alt="Play video"
                />
              )}
            </React.Fragment>
          )}
        </div>
        <div
          className={`article-hero-B__content ${
            !heroImage || !heroImage.background
              ? 'article-hero-B__no-img'
              : ''
          }`}
        >
          <div className="article-hero-B__headline-parent">
            <h1
              className={`article-hero-B__headline headline--xl headline--highlight headline--highlight-${highlightColor} ${textColor}`}
              style={headlineStyle}
            >
              {title}
            </h1>
          </div>
          <div className="article-hero-B__date-and-social">
            <p className="article-hero-B__date date">{postDate}</p>
            <SocialShare />
          </div>
        </div>
      </div>
    );
  }
}
